export default {
  AK: {
    en: 'Alaska',
  },
  AL: {
    en: 'Alabama',
  },
  AR: {
    en: 'Arkansas',
  },
  AZ: {
    en: 'Arizona',
  },
  CA: {
    en: 'California',
  },
  CO: {
    en: 'Colorado',
  },
  CT: {
    en: 'Connecticut',
  },
  DE: {
    en: 'Delaware',
  },
  DC: {
    en: 'District Of Columbia',
  },
  FL: {
    en: 'Florida',
  },
  GA: {
    en: 'Georgia',
  },
  HI: {
    en: 'Hawaii',
  },
  ID: {
    en: 'Idaho',
  },
  IL: {
    en: 'Illinois',
  },
  IN: {
    en: 'Indiana',
  },
  IA: {
    en: 'Iowa',
  },
  KS: {
    en: 'Kansas',
  },
  KY: {
    en: 'Kentucky',
  },
  LA: {
    en: 'Louisiana',
  },
  ME: {
    en: 'Maine',
  },
  MD: {
    en: 'Maryland',
  },
  MA: {
    en: 'Massachusetts',
  },
  MI: {
    en: 'Michigan',
  },
  MN: {
    en: 'Minnesota',
  },
  MS: {
    en: 'Mississippi',
  },
  MO: {
    en: 'Missouri',
  },
  MP: {
    en: 'Northern Marianas',
  },
  MT: {
    en: 'Montana',
  },
  NE: {
    en: 'Nebraska',
  },
  NV: {
    en: 'Nevada',
  },
  NH: {
    en: 'New Hampshire',
  },
  NJ: {
    en: 'New Jersey',
  },
  NM: {
    en: 'New Mexico',
  },
  NY: {
    en: 'New York',
  },
  NC: {
    en: 'North Carolina',
  },
  ND: {
    en: 'North Dakota',
  },
  OH: {
    en: 'Ohio',
  },
  OK: {
    en: 'Oklahoma',
  },
  OR: {
    en: 'Oregon',
  },
  PA: {
    en: 'Pennsylvania',
  },
  PR: {
    en: 'Puerto Rico',
  },
  RI: {
    en: 'Rhode Island',
  },
  SC: {
    en: 'South Carolina',
  },
  SD: {
    en: 'South Dakota',
  },
  TN: {
    en: 'Tennessee',
  },
  TX: {
    en: 'Texas',
  },
  UT: {
    en: 'Utah',
  },
  VT: {
    en: 'Vermont',
  },
  VA: {
    en: 'Virginia',
  },
  WA: {
    en: 'Washington',
  },
  WV: {
    en: 'West Virginia',
  },
  WI: {
    en: 'Wisconsin',
  },
  WY: {
    en: 'Wyoming',
  },
  AA: {
    en: 'U.S. Armed Forces – Americas',
  },
  AE: {
    en: 'U.S. Armed Forces – Europe',
  },
  AP: {
    en: 'U.S. Armed Forces – Pacific',
  },
  VI: {
    en: 'Virgin Islands',
  },
} as const
